export default __webpack_public_path__ + "static/media/pianoActiveBtn.69403faa.png";